import axiosGlobalInstance from './configHttpInstance/http-instance';
import mockDetail from './fakes/environment-detail';

const environmentDetail = (id) => {
  const useFake = !!Number(process.env.REACT_APP_MOCK_API);

  if(useFake) {
    return new Promise((resolve) => {
      setTimeout(() => resolve(mockDetail), 500);
    });
  }

  const httpInstance = axiosGlobalInstance();

  return httpInstance({
    method: 'GET',
    url: `/environments/${id}`,
  });
}

export default environmentDetail;

